<template>
  <div
    :aria-orientation="orientation"
    class="border-gray-900/10"
    :class="dividerClass"
    role="separator"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  orientation?: 'horizontal' | 'vertical'
  responsive?: boolean
}>()

const orientation = computed(() => {
  if (props.responsive) return 'horizontal'
  return props.orientation ?? 'horizontal'
})
const isVertical = computed(() => orientation.value === 'vertical')

const dividerClass = computed(() => {
  if (props.responsive) {
    return 'w-full border-t-2 md:w-auto md:border-t-0 md:border-l-2 md:my-0 md:mx-2'
  }
  return {
    'w-full border-t-2 my-2 md:my-4': !isVertical.value,
    'h-full border-l-2 mx-2 md:mx-4': isVertical.value
  }
})
</script>
